import { get } from 'lodash'
import { required } from '../../../../utils/validation'

export const validate = (val, props) => {
  const { values } = props

  const validateReason = get(props, 'isAssessorManagementEnabled') && (get(props, 'showReasons') || get(props, 'deletionReasons'))

  const errors = {
    reason: validateReason && required(get(values, 'reason'))
  }

  return errors
}

